const useStorage = storage => {
  const setItem = (key, value) => {
    try {
      return storage().setItem(key, value)
    } catch (error) {
      return null
    }
  }

  const getItem = key => {
    try {
      return storage().getItem(key)
    } catch (error) {
      return null
    }
  }

  const removeItem = key => {
    try {
      return storage().removeItem(key)
    } catch (error) {
      return null
    }
  }

  const clear = () => {
    try {
      return storage().clear()
    } catch (error) {
      return null
    }
  }

  const key = index => {
    try {
      return storage().key(index)
    } catch (error) {
      return null
    }
  }

  const length = () => {
    try {
      return storage().length
    } catch (error) {
      return null
    }
  }

  return {
    setItem,
    getItem,
    removeItem,
    clear,
    key,
    get length() {
      return length()
    },
  }
}

export const useLocalStorage = () => useStorage(() => localStorage)

export const useSessionStorage = () => useStorage(() => sessionStorage)
